import { render, staticRenderFns } from "./TeacherCabinet.vue?vue&type=template&id=71399d51"
import script from "./TeacherCabinet.vue?vue&type=script&lang=js"
export * from "./TeacherCabinet.vue?vue&type=script&lang=js"
import style0 from "./TeacherCabinet.vue?vue&type=style&index=0&id=71399d51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports